export default __webpack_public_path__ + "static/media/SourceSans3-SemiBoldItalic.6bdb2306.ttf";